<template>
    <div>
        <el-table
            :data="page.records"
            :hightlight-current-row="hightlightCurrentRow"
            @selection-change="selectionChange"
            @current-change="handleCurrentHandle"
            v-loading="loading"
            element-loading-text="加载中"
            :border="border"
            :stripe="stripe"
            :show-overflow-tooltip="showOverflowTooltip"
            :max-height="maxHeight"
            :size="size"
            :align="align"
            style="width: 100%;">
            <el-table-column
                type="selection"
                width="40"
                v-if="showBatchDelete & showOperator"
                >
            </el-table-column>
            <slot name="first"></slot>
            <el-table-column
                v-for="column in columns"
                header-align="center" align="center"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :min-width="column.minWidth"
                :fixed="column.fixed"
                :key="column.prop"
                :type="column.type"
                :formatter="column.formatter"
                :sortable="column.sortable==null?true:column.sortable">
            </el-table-column>
            <el-table-column
                label="操作"
                :width="actionWidth"
                fixed="right"
                v-if="showOperation"
                header-align="center"
                align="center">
                <template slot-scope="scope">
                    <template>
                        <span style='visibility:hidden'>
                            {{showMore}}
                        </span>
                    </template>
                    <template v-if='showEdit'>
                        <perm-button
                            icon="fa fa-edit"
                            :label="editLabel"
                            :perms="permsEdit"
                            :size="size"
                            @click="handleEdit(scope.$index, scope.row)" />
                    </template>
                    <template v-if='showMore'>
                        <perm-button
                            icon="fa el-icon-more"
                            label="查看"
                            :perms="permsEdit"
                            :size="size"
                            type='primary'
                            @click="handleShoMore(scope.$index, scope.row)" />
                    </template>
                    <perm-button
                        v-if="showDelete"
                        icon="fa fa-trash"
                        label="删除"
                        :perms="permsDelete"
                        :size="size"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)" />
                        <!-- 公共按钮 -->
                    <perm-button
                        v-if="showPublic"
                        icon="el-icon-star-off"
                        :label="titlePublic"
                        :perms="permsPublic"
                        :size="size"
                        type="primary"
                        @click="handlePublic(scope.$index, scope.row)" />
                    <perm-button
                        v-if="showRefresh"
                        icon="fa fa-trash"
                        label="刷新考试码"
                        :perms="permsRefresh"
                        :size="size"
                        type="primary"
                        @click="handleRefresh(scope.$index, scope.row)" />
                    <perm-button
                        v-if="showBind"
                        label="换绑"
                        :perms="permsEdit"
                        :size="size"
                        type="primary"
                        @click="handleBind(scope.$index, scope.row)" />
                    <perm-button
                        v-if="showExipire"
                        label="延期"
                        :perms="permsEdit"
                        :size="size"
                        type="danger"
                        @click="handleExpire(scope.$index, scope.row)" />
                    <perm-button
                        v-if="showCall"
                        label="呼叫"
                        :perms="permsEdit"
                        :size="size"
                        type="primary"
                        @click="handleCall(scope.$index, scope.row)" />
                    <perm-button
                        v-if="showCopy"
                        label="复制"
                        :perms="permsEdit"
                        :size="size"
                        type="primary"
                        @click="handleCopy(scope.$index, scope.row)" />
                    <perm-button
                        v-if="showPush"
                        label="推送"
                        :perms="permsEdit"
                        :size="size"
                        type="success"
                        @click="handlePush(scope.$index, scope.row)" />
                </template>
            </el-table-column>
            <slot></slot>
        </el-table>
        <!-- 分页 -->
        <div class="toolbar" style="padding: 10px;">
            <perm-button
                label="批量删除"
                :perms="permsDelete"
                :size="size"
                type="danger"
                @click="handleBatchDelete()"
                :disabled="this.selections.length===0"
                style="float:left;"
                v-if="showBatchDelete & showOperation">
            </perm-button>
            <el-pagination
                v-if="page.records"
                background
                layout="total, prev, pager, next"
                :total="page.total"
                :current-page="page.current"
                :page-size="page.size"
                @current-change="refreshPageRequest"
                style="float:right;">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import PermButton from '../PermButton/Index'
export default {
    name: 'PermTable',
    components: { PermButton },
    props: {
        columns: Array, // 表格列配置
        page: Object, // 表格分页数据
        permsEdit: String, // 编辑权限标识
        permsDelete: String, // 删除权限标识
        permsRefresh: String,
        permsPublic: String, // 公共按钮权限标识
        titlePublic: String, // 公共按钮标题
        size: { // 尺寸样式
            type: String,
            default: 'mini'
        },
        align: { // 文本对齐方式
            type: String,
            default: 'left'
        },
        maxHeight: { // 表格最大高度
            type: Number,
            default: 1000
        },
        showOperator: { // 是否显示操作组件
            type: Boolean,
            default: true
        },
        border: { // 是否显示边框
            type: Boolean,
            default: false
        },
        stripe: { // 是否显示斑马线
            type: Boolean,
            default: true
        },
        hightlightCurrentRow: { // 是否高亮显示当前行
            type: Boolean,
            default: true
        },
        showOverflowTooltip: { // 是否单行显示
            type: Boolean,
            default: true
        },
        showBind: {
            type: Boolean,
            default: false
        },
        showExipire: {
            type: Boolean,
            default: false
        },
        showCall: {
            type: Boolean,
            default: false
        },
        showOperation: { // 是否显示操作组件
            type: Boolean,
            default: true
        },
        showBatchDelete: { // 是否显示批量删除组件
            type: Boolean,
            default: false
        },
        showMore: {
            type: Boolean,
            default: false
        },
        // 显示删除
        showDelete: {
            type: Boolean,
            default: true
        },
        showPublic: {
            type: Boolean,
            default: false
        },
        showEdit: {
            type: Boolean,
            default: true
        },
        editLabel: {
            type: String,
            default: '编辑'
        },
        showRefresh: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        actionWidth: {
            type: Number,
            default: 210
        },
        showCopy: {
            type: Boolean,
            default: false
        },
        showPush: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pageRequest: {
                current: 1,
                size: 10
            },
            selections: [] // 列表选中列
        }
    },
    methods: {
        // 分页查询
        findPage: function() {
            this.loading = true
            const callback = res => {
                this.loading = false
            }
            this.$emit('findPage', { pageRequest: this.pageRequest, callback: callback })
        },
        // 切换选择
        selectionChange: function(selections) {
            debugger
            this.selections = selections
            this.$emit('selectionChange', { selections: selections })
        },
        // 当前选择
        handleCurrentHandle: function(val) {
            debugger
            this.$emit('handleCurrentHandle', { val: val })
        },
        // 刷新页面
        refreshPageRequest: function(current) {
            this.pageRequest.current = current
            this.findPage()
        },
        // 编辑
        handleEdit: function(index, row) {
            this.$emit('handleEdit', { index: index, row: row })
        },
        // 删除
        handleDelete: function(index, row) {
            this.$emit('handleDelete', { index: index, row: row })
        },
        // 批量删除
        handleBatchDelete: function() {
            const ids = this.selections.map(item => item.id).toString()
            this.delete(ids)
        },
        handleCall(index, row) {
            if (!row.mobile) {
                this.$message({
                    message: '暂无电话，无法呼叫！',
                    type: 'error'
                })
                return
            }
            this.call(row.mobile)
        },
        call(str) {
            document.querySelector('.phone-sdk_phone-ui-pc-operation-icon_operation-icon-container').click()
            setTimeout(() => {
                const numberBtns = document.querySelectorAll('.phone-sdk_phone-ui-pc-dial-panel_keyboard-key')
                if (numberBtns.length === 0) {
                    return
                }
                for (let i = 0; i < str.length; i++) {
                    const number = Number(str[i])
                    let index = number - 1
                    if (index < 0) {
                        index = 10
                    }
                    numberBtns[index].click()
                }
                setTimeout(() => {
                    const btnEl = document.querySelector('.phone-sdk_phone-ui-pc-dial-panel_dial-btn')
                    btnEl.click()
                }, 500)
            }, 500)
        },
        handleRefresh: function(index, row) {
            this.$emit('handleRefresh', { index: index, row: row })
        },
        handlePublic: function(index, row) {
            this.$emit('handlePublic', { index: index, row: row })
        },
        handleBind: function(index, row) {
            this.$emit('handleBind', { index: index, row: row })
        },
        handleExpire: function(index, row) {
            this.$emit('handleExpire', { index: index, row: row })
        },
        // 查看性情
        handleShoMore(index, row) {
            this.$emit('handleShoMore', { index: index, row: row })
        },
        // 删除操作
        delete: function(ids) {
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                const params = []
                const idArray = (ids + '').split(',')
                for (let i = 0; i < idArray.length; i++) {
                    params.push({ 'id': idArray[i] })
                }
                this.loading = true
                const callback = res => {
                    if (res.success) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.findPage()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                    this.loading = false
                }
                this.$emit('handleDelete', { params: params, callback: callback })
            }).catch(() => {})
        },
        handleCopy: function(index, row) {
            this.$emit('handleCopy', { index: index, row: row })
        },
        handlePush: function(index, row) {
            this.$emit('handlePush', { index: index, row: row })
        }
    },
    mounted() {
        this.$forceUpdate()
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Component/PermTable/Index.vue